<template lang="pug">
v-row.mb-10
  v-container.fill-height(fluid v-if="!loggedin")
    v-row(align="center", justify="center")
        v-col(cols="12" sm="8" md="4")
          v-card(class="elevation-12")
            v-toolbar(color="primary" dark flat)
              v-toolbar-title Power Trip Dealer Signup
            v-card-text
                v-form(ref="form" v-model="valid" lazy-validation)
                                  
                  h3.mt-4(v-if="!existingUser") Create a new account
                  v-text-field(label="Dealership Name" name="serviceName" prepend-icon="mdi-car" type="text" v-model="serviceName" :rules="[rules.required, rules.minimum]")
                  v-text-field(v-if="!existingUser" label="Your First Name" name="firstname" prepend-icon="mdi-account-box" type="text" v-model="firstname" :rules="[rules.required, rules.minimum]")
                  v-text-field(v-if="!existingUser" label="Your Surname" name="surname" prepend-icon="mdi-account-box" type="text" v-model="surname" :rules="[rules.required, rules.minimum]")
                  v-text-field(v-if="!existingUser" label="Username" name="username" prepend-icon="mdi-at" type="text" v-model="username" :rules="[rules.required, rules.minimum]")
                  v-text-field(v-if="!existingUser" label="Your Email" name="email" prepend-icon="mdi-email-outline" type="text" v-model="email" autocomplete="username" :rules="[rules.required, rules.email]")
                  v-text-field#password(
                    v-if="!existingUser"
                    label="Password",
                    name="password",
                    prepend-icon="mdi-lock",
                    type="password",
                    autocomplete="current-password",
                    :rules="[rules.required, rules.minimum]"
                                :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append="() => (showPassword = !showPassword)"
                :type="showPassword ? 'text' : 'password'"
                  )
                v-card-actions
                  v-spacer
                  v-btn.secondary(@click="login"  v-if="!existingUser") I have a Power Trip Account
                  v-btn(@click="newSignup" text v-if="existingUser") Log Out
                  v-btn(color="primary" @click="signup" v-if="!existingUser") Sign Up
                  v-btn(color="primary" @click="signup" v-if="existingUser" ) Register
    v-snackbar(v-model="snackbar" :timeout="4000") {{ messageText }}
</template>

<script>
export default {
  data() {
    return {
      messageText: "",
      snackbar: false,
      valid: true,
      loggedin: false,
      serviceName: "",
      email: "",
      password: "",
      firstname: "",
      surname: "",
      username: "",
      showPassword: false,
      existingUser: false,
      rules: {
        required: (value) => !!value || "Required.",
        minimum: (value) => (value && value.length >= 3) || "Minimum 3 Characters",
        counter: (value) => (value && value.length <= 20) || "Max 20 characters",
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
    };
  },
  mounted() {
    localStorage.removeItem("servicecode");
    //localStorage.removeItem("credentials");
    this.existingUser = !!this.$user;
  },
  methods: {
    login() {
      this.$router.push("/dealer");
    },
    newSignup() {
      this.$user = null;
      this.existingUser = false;
    },
    async signup() {
      if (this.$refs.form.validate()) {
        var results = await this.$dealer.signup(
          this.serviceName,
          this.email,
          this.password,
          this.firstname,
          this.surname,
          this.username,
          this.existingUser
        );

        if (results.serviceID) {
          this.$serviceCode = results.serviceID;
          localStorage.setItem("servicecode", results.serviceID);
          window.location.href = "/#/dealer";
          window.location.reload();
        } else {
          this.snackbar = true;
          this.messageText = "This account is already registered";
        }
      }
    },
  },
};
</script>
<style scoped>
header {
  min-height: 64px;
}
</style>
